import 'normalize.css/normalize.css';
import './styles/app.scss';
import * as axios from 'axios'; // using axios instead of xhr/ajax
// import $ from 'jquery/dist/jquery';
import * as toastr from 'toastr';
// import './/../node_modules/toastr/build/toastr.css';


let searchInput = document.getElementById('searchInput');
let searchButton = document.getElementById('searchButton');
let nameValue = document.getElementById('nameVal');
let networkVal = document.getElementById('networkVal');
let numberVal = document.getElementById('numberVal');
let table = document.getElementById('table_container');
let dateYear = document.getElementById('date');

const numberURL = 'https://client.teamcyst.com/speedpay/checknetwork-api.php';
const regExLong = /^(?=\d{12}$)(233)\d+/;
const regExShort = /^(?=\d{10}$)(0)\d+/;

function searchNumber(phoneNumber) {
    axios.post(numberURL, {
            number: phoneNumber,
            apikey: '5e39a256da48261538e862057cde129f0959b061'
        })
        .then((next) => {
           // console.log('response from server: ', next.data);
            return setValues(next.data);
        })
        .then(next => {
           // console.log('fields set');
            return;
        })
        .catch(error => {
            // console.log('Error: ', error);
            toastr.error('There was a connection error. Please check your internet connection and try again.');
        });
}

function setValues(data) {
    return new Promise((resolve, reject) => {
        try {
           // console.log(data);
            nameValue.textContent = data.name;
            networkVal.textContent = data.network;
            numberVal.textContent = data.number;
            table.style.opacity = 1;
            resolve();
        } catch (error) {
            //console.log('set fields error: ', error);
            toastr.error('There was an error. Please wait a moment and try again.');
            reject();
        }
    });
}

function validateNumber(number) {
    return new Promise(function (resolve, reject) {
        if (regExLong.test(number) || regExShort.test(number)) {
            resolve(true);
        } else {
            // show an invalid toast
            toastr.error('The phone number you have entered is not valid. Please try again.')
            reject('invalid');
        };
    });
}

function submitNumber() {
    let number = searchInput.value || ' ';
    // console.log('Number: ', number);
    if (number) {
        validateNumber(number)
            .then((next) => {
                // console.log('validation result: ', next);
                searchNumber(number);
            })
            .catch(function (error) {

            });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    // init();
    searchButton.addEventListener('click', submitNumber);

    dateYear.textContent = (new Date()).getFullYear();
});
